import React, { Component } from 'react'
import { Menu, Row, Input, Button, Tooltip, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { RESTExecutor, withDomains } from '../lib/domain';
import { getMenuItem } from './side_menu';
import { NetworkDelaySearch } from '../lib/util';
import { KeyboardArrowRightOutlined } from '@material-ui/icons';

class ComplexMenu extends Component {
    constructor(props) {
        super(props)

        this.max_content = this.props.max_content || 3;
        this.key_position=this.props.key_position||2;

        // To know if there empty list are from main list or searched list
        this.isSearching=false;

        this.state = {
            loading:true,
            error:false,
            searchExpanded: false,
            list_data:[],
            old_list_data:[]
        };

        this.list_submenu=RESTExecutor.list().config({
            url:this.props.api_url||'/test',
            params:{
                per_page:this.props.limit||3
            }
        }).callbacks((success)=>{
            let extra_obj={}
            if(!this.state.searchExpanded){
                extra_obj={
                    old_list_data:success.result.rows||[]
                };
            }
            this.setState({
                list_data:success.result.rows||[],
                loading:false,
                error:false,
                ...extra_obj
            });

        },(error)=>{
            this.setState({
                error:true,
                loading:false
            })
        })
        .connect(props.domains.menu);

        if(this.props.api_url){
            this.list_submenu.execute();
        }

        this.delay_search=new NetworkDelaySearch();


    };

    toggleSearchExpanded = () => {
        this.setState({
            searchExpanded: !this.state.searchExpanded
        }, () => {
            if (this.state.searchExpanded) {
                this.setState({
                    list_data:JSON.parse(JSON.stringify(this.state.old_list_data))
                })
            }
        })
    }

    render() {

        let list_submenu_res=this.list_submenu.response();
        let list_submenu_data=list_submenu_res.result||{};
        let submenu_list=list_submenu_data.rows||[];


        let title = this.props.title || "";
        let iconImage = this.props.iconImage;
        let menuKey=this.props.menuKey||"";
        let menuKeys=menuKey.split('/');
        // console.log("keys",menuKey,menuKeys)
        let activeKey=menuKeys[this.key_position]||"";

        let urlMaker = typeof this.props.urlMaker === 'function' ? this.props.urlMaker : (item) => item

        let subMenu = [
            {
                title: `${title} 1`,
                key: `${title.toLowerCase()}1`,
                url: urlMaker(`${title.toLowerCase()}1`)
            },
            {
                title: `${title} 2`,
                key: `${title.toLowerCase()}2`,
                url: urlMaker(`${title.toLowerCase()}2`)
            },
            {
                title: `${title} 3`,
                key: `${title.toLowerCase()}3`,
                url: urlMaker(`${title.toLowerCase()}3`)
            }
        ]
        const list_data=this.state.searchExpanded?this.state.list_data:this.state.old_list_data;

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                position: 'relative'
            }}>
            {this.props.viewAll?getMenuItem({
                    type:'main',
                    menuKey:menuKey,
                    url:this.props.viewAll,
                    icon:this.props.icon,
                    title:title,
                    iconRight:<KeyboardArrowRightOutlined  style={{}}/>,
                    // mainStyle:{borderTop:'1px solid #fff'},
                    // topStyle:{marginTop:4,marginBottom:4}
                }):
                <Row type='flex' justify='space-between' style={{
                    color: 'white',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    paddingTop: 8,
                    paddingBottom: 8,
                    borderTop:'1px solid #fff'
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        cursor: 'pointer'
                    }}>
                        

                        <span style={{
                            margin: 0,
                            // marginLeft: 16,
                            fontSize: 16,
                            fontWeight: 'bold',
                            opacity: 0.8,
                        }}>{title}</span>
                    </div>

                    {!this.props.no_search&&
                    <div>
                        {/* <Icon type='search'
                            onClick={() => {
                                this.toggleSearchExpanded()
                            }}
                            style={{
                                fontSize: 16
                            }} /> */}
                    </div>
                    }
                </Row>
                }

                {this.state.searchExpanded &&
                    <Row type='flex' style={{ flexWrap: 'nowrap' }}>
                        <Input.Search
                        autoFocus
                        className='white-search'
                            size='small'
                            onChange={(e)=>{
                                if(this.props.api_url){
                                    let value=e.target.value;
                                    this.delay_search.onSearch(()=>{
                                    this.setState({
                                        loading:true,
                                        error:false
                                    })
                                    this.list_submenu.config(
                                    {
                                        params:{
                                            per_page:this.props.limit||3,
                                            query:value
                                        }
                                    }
                                ).execute();
                                })
                                }
                            }}
                            onSearch={(e)=>{
                                // if(this.props.api_url){
                                //     this.setState({
                                //         loading:true,
                                //         error:false
                                //     })
                                // this.list_submenu.config(
                                //     {
                                //         params:{
                                //             per_page:this.props.limit||3,
                                //             query:e
                                //         }
                                //     }
                                // ).execute();
                                // }
                            }}
                            placeholder={`Search for`}
                        // onBlur={()=>{
                        //     this.toggleSearchExpanded()
                        // }}
                        />
                        <Button type='link' icon='cross' style={{ color: 'white' }} onClick={this.toggleSearchExpanded}></Button>
                    </Row>
                }
             {
                    this.state.loading?
                    <Spin  className='white-spin' spinning={this.state.loading}/>
                    :<div style={{
                        
                    }}>
                    {list_data.length==0&&!this.state.error&&<div style={{opacity:0.5,textAlign:'center',paddingBottom:6}}>No Data</div>}
                    {list_data.map((item, index) => {
                        if(index+1 > (this.props.limit||3)){
                            return "";
                        }
                        if(this.props.expandable){
                            return getMenuItem({
                                type:'expandable',
                                menuKey:menuKey,
                                title:item.name,
                                index:item.id,
                                active_url:`/${urlMaker(item.id)}`,
                                title_url:this.props.title_url&&urlMaker(`${item.id}`),
                                param:item.id,
                                childItem:this.props.childItem
                            })
                        }
                        return getMenuItem({
                            type:'secondary',
                            menuKey:menuKey,
                            title:item.name,
                            index:item.id,
                            urlMaker:urlMaker,
                            param:item.id,
                            // icon:item.favourite&& <Icon type="star" style={{
                            //     fontSize:24
                            // }} theme={'twoTone'}  twoToneColor='#52c41a' 
                            // />,
                            isActive:`${item.id}`==activeKey

                        })

                        return <Link to={`/${urlMaker(`${item.id}`)}`}
                            key={index}
                        ><Row type='flex' justify='start'
                            className='menu-item'
                            style={{
                                color: 'white',
                                alignItems: 'center',
                                flexWrap: 'nowrap',
                                paddingTop: 8,
                                paddingBottom: 8,
                                cursor: 'pointer',
                                marginTop: 2,
                                marginBottom: 2,
                                backgroundColor: menuKey.includes(urlMaker(`${item.id}`)) ? 'rgba(255, 255, 255, 0.5)' : 'transparent',
                                borderRadius: 10,
                                opacity:menuKey.includes(urlMaker(`${item.id}`)) ?1:0.8
                            }}>
                                <span style={{
                                    margin: 0,

                                    marginLeft: 16
                                }}>{item.name}</span>

                                <div>

                                </div>

                            </Row>
                        </Link>
                    })
                }</div>
                }

                {this.state.error && !this.state.loading && <Button type='link' 
                onClick={()=>{
                    this.setState({loading:true})
                    this.list_submenu.execute()
                }}
                style={{
                    color:'white'
                }}>Retry</Button>}

                {/* {this.props.viewAll && !this.state.error&&!this.state.loading && <Link to={`/${this.props.viewAll}`}>
                    <Row type='flex' justify='start' style={{
                        color: 'white',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        paddingTop: 8,
                        paddingBottom: 8,
                        cursor: 'pointer'
                    }}>
                        <Button type='link' style={{
                            color: 'white',

                        }}>
                            <span style={{
                                textDecorationLine: 'underline'
                            }}> {this.props.view_all_text||"View All"}</span>
                        </Button>

                        <div>

                        </div>

                    </Row>
                </Link>} */}

            </div>
        )
    }
}

export default withDomains(ComplexMenu,"menu")
